module.exports = __webpack_public_path__ + "img/star.031cf307.svg";